import { CONTENT_ARTICLE_ENTRIES } from './content-article-registry.generated';

export interface ContentSection {
  heading: string;
  paragraphs: string[];
  bullets?: string[];
}
export interface ContentFaq {
  question: string;
  answer: string;
}
export interface ContentPage {
  slug: string;
  title: string;
  description: string;
  summary: string;
  sections: ContentSection[];
  faqs: ContentFaq[];
  related: string[];
  category?: string;
  sources?: { label: string; url: string }[];
  tool?:
    | 'percentile'
    | 'mental-age'
    | 'brain-age'
    | 'reaction-time'
    | 'memory'
    | 'color-vision'
    | 'cognitive-style'
    | 'learning-style';
}

export const CONTENT_LANGUAGE = 'en';
export const CONTENT_BASE_PATH = '/en/content/';
export const CONTENT_LAST_REVIEWED = '2026-07-31';

export function contentUrl(slug: string, language = CONTENT_LANGUAGE): string {
  return `/${language}/content/${slug}/`;
}

export const CONTENT_PAGES: ContentPage[] = CONTENT_ARTICLE_ENTRIES.filter(
  ({ language }) => language === CONTENT_LANGUAGE,
).map(({ page }) => page);

export const CONTENT_PAGE_MAP = new Map(CONTENT_PAGES.map((page) => [page.slug, page]));
